import { render, staticRenderFns } from "./VerDetalleRecepcionActividadModal.vue?vue&type=template&id=1594a547&"
import script from "./VerDetalleRecepcionActividadModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleRecepcionActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports